import { Sizes } from "../_app/cuchillo/core/Sizes";

export default class FlappyBG {
  position = {
    x: 0,
    y: 0
  }
  size = {
    width: 360 * Sizes.RATIO,
    height: 540 * Sizes.RATIO
  }

  constructor(__call) {
    this.image = new Image();
    this.image.src = '/assets/images/bg.png';
    this.image.onload = __call;
  }

  load(callback) {

  }

  draw(ctx) {
    ctx.drawImage(this.image, this.position.x, this.position.y, this.size.width, this.size.height);
  }

  dispose() {
    // Eliminar referencia a la imagen
    this.image.src = "";
    this.image.onload = null;
    this.image = null;
  
    // Restablecer propiedades a sus valores iniciales o null
    this.position = {
      x: 0,
      y: 0
    }
  }
}
